import DashboardLayout from "../../lib/components/layouts/dashboard";
import PatientBookAppointment from "lib/components/appointments/patient/patient-book-appointment";
import { useContext } from "react";
import { AppContext } from "lib/contexts/app-context";
import { isPatientUser } from "lib/utils/util";
import { PAGE_ROUTES } from "lib/constants/page-routes";

const PatientBookAppointmentPage = () => {
  const { appState } = useContext(AppContext);

  const BreadcrumbItems = [
    {
      label: "Dashboard",
      path: isPatientUser(appState?.userRole)
        ? PAGE_ROUTES.PATIENT.Dashboard
        : PAGE_ROUTES.PRACTITIONER.Dashboard,
    },
    {
      label: "Book Appointment",
      path: isPatientUser(appState?.userRole)
        ? PAGE_ROUTES.PATIENT.BookAppointment
        : PAGE_ROUTES.PATIENT.BookAppointment,
    },
  ] as BreadcrumbItem[];

  return (
    <DashboardLayout breadcrumbItems={BreadcrumbItems}>
      <PatientBookAppointment />
    </DashboardLayout>
  );
};

export default PatientBookAppointmentPage;
